import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem("token");

    if (token) {
      request = request.clone({
        headers: request.headers.set("Authorization", `Bearer ${token}`),
        setHeaders: {
          "ngrok-skip-browser-warning": "true",
        },
      });
      return next.handle(request);
    } else {
      return next.handle(request);
    }
  }
}
